import PropTypes from 'prop-types';
import React from 'react';

import ODMarker from 'ondemand/components/ODMarker';
import RideMarker from 'ondemand/components/RideMarker';
import RidePath from 'common/components/RidePath';
import WalkPath from 'ondemand/components/WalkPath';

const RideDirectionsMapLayer = (
  {
    destination,
    destinationDistance,
    dropoff,
    origin,
    originDistance,
    pickup,
  }
) => (
  <div>
    <RideMarker position={pickup.position} type="pickup" />
    <RideMarker position={dropoff.position} type="dropoff" />
    {originDistance >= 1 &&
      <div>
        <ODMarker position={origin.position} />
        <WalkPath start={origin.position} end={pickup.position} />
      </div>}
    {destinationDistance >= 1 &&
      <div>
        <ODMarker position={destination.position} />
        <WalkPath start={destination.position} end={dropoff.position} />
      </div>}
    <RidePath pickup={pickup.position} dropoff={dropoff.position} />
  </div>
);

RideDirectionsMapLayer.propTypes = {
  destination: PropTypes.object,
  destinationDistance: PropTypes.number,
  dropoff: PropTypes.object,
  origin: PropTypes.object,
  originDistance: PropTypes.number,
  pickup: PropTypes.object,
};

export default RideDirectionsMapLayer;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideDirectionsMapLayer.js